import { Rating } from "./api";

const RATING_API_BASE_URL = "https://data-busca.liatalk.ai/api/v1";

export async function fetchRatingByPhone(phoneNumber: string): Promise<Rating | null> {
	try {
		const response = await fetch(`${RATING_API_BASE_URL}/rating?phone=${encodeURIComponent(phoneNumber)}`, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
		});

		if (!response.ok) {
			console.error(`Failed to fetch rating: ${response.status} ${response.statusText}`);
			return null;
		}

		const data = await response.json();
		return data as Rating;
	} catch (error) {
		console.error("Error fetching rating:", error);
		return null;
	}
}

